import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs3/core-js/number/max-safe-integer";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reverse";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _URL from "@babel/runtime-corejs3/core-js/url";
import moment from "moment";
import numeral from "numeral";
import { getDefaultProfilePhoto } from "../utils";
import { ENVIRONMENT, S3_BUCKET_URL } from "../constants";
import TimelineAssigneeTooltip from "@Shared/@HandlebarsTemplates/general/_timeline-assignee-tooltip.hbs";
import UserMalePlaceHolderAsset from "@Shared/@Assets/img/user-male-placeholder.png";
import Vue from "vue";
import { isEmpty, sortBy, startsWith } from "lodash";
export const avatarPlaceholder = person => {
  if (!person) person = {
    givenName: "John",
    familyName: "Doe"
  };
  const {
    givenName,
    profilePhoto,
    photoVersion,
    username
  } = person;
  if (!givenName) return UserMalePlaceHolderAsset;
  if (profilePhoto) {
    //if the profilePhoto is a string, then it ia an URL
    if (typeof profilePhoto === "string") return profilePhoto;
    return `${S3_BUCKET_URL}/profile-photos/${username}?v=${photoVersion}`;
  }
  return getDefaultProfilePhoto(person);
};
export const followupClassification = date => {
  if (!date) return "";
  const today = moment().startOf("day");
  const momentFromDate = moment(date, "YYYY-MM-DD");
  const daysDiff = momentFromDate.diff(today, "days");
  if (daysDiff < 0) {
    return "past-due";
  } else if (daysDiff == 0) {
    return "active";
  } else if (daysDiff <= 14) {
    return "upcoming";
  } else {
    return "planned";
  }
};
export const activityClass = (activities, onlyTop) => {
  const allActiveClasses = _reduceInstanceProperty(activities).call(activities, (acc, activity) => {
    const classification = followupClassification(activity.scheduledDate);
    acc.push(classification);
    return acc;
  }, []);
  let uniqueActiveClasses = [...new _Set(allActiveClasses)];
  uniqueActiveClasses = sortBy(uniqueActiveClasses, element => {
    const priority = {
      "past-due": 3,
      active: 2,
      upcoming: 1,
      planned: 0
    };
    return priority[element];
  });
  if (onlyTop) {
    return _sliceInstanceProperty(uniqueActiveClasses).call(uniqueActiveClasses, -1)[0];
  } else {
    return uniqueActiveClasses.join(" ");
  }
};
export const userAgent = userAgent => {
  var _context;
  return _includesInstanceProperty(_context = navigator.sayswho).call(_context, userAgent);
};
export const parsePercentageDecimal = value => {
  return `${(value * 100).toFixed(3)}%`;
};
export const parsePercentage = value => value ? `${Math.round(value * 100)}%` : "N/A";
export const setNAValue = value => value || "N/A";
export const idForAgents = index => `agent-clients-table-${index}`;
export const getVisible = () => {
  return true;
};
export const plusOne = index => index + 1;
export const minusOne = index => index - 1;
export const randomNumber = () => {
  return Math.floor(Math.random() * _Number$MAX_SAFE_INTEGER) + 1;
};
export const setVariable = (varName, varValue, options) => {
  options.data.root[varName] = varValue;
};
export const escapeURL = url => {
  return escape(url);
};
export const encodeURI = url => {
  return encodeURI(url);
};
export const allEmptyFilenames = fileList => {
  return _filterInstanceProperty(fileList).call(fileList, file => file.filename).length === 0;
};
export const getProgressItemVariation = activtyType => {
  const variationFor = {
    email: "0",
    file: "-45",
    "follow-up": "-30",
    note: "30",
    "account-creation": "45"
  };
  return variationFor[activtyType] + "deg";
};
export const arrayLength = array => array.length;
export const getProgressiveIndex = (sections, index) => {
  let top = 0;
  sections.forEach(section => {
    if (section.card > top) top = section.card;
  });
  return index + top;
};
export const splitStringArray = arrayString => {
  const array = arrayString.replace("[", "").replace("]", "").replace("},", "},**").split(",**");
  return _mapInstanceProperty(array).call(array, element => {
    if (_includesInstanceProperty(element).call(element, "}")) return JSON.parse(element);
  });
};
export const parseToJSON = jsonString => JSON.parse(jsonString);

/**
 * Helper to show a block only to a specific account type
 */
export const onlyFor = function (...params) {
  const [options, ...types] = _reverseInstanceProperty(params).call(params);
  const {
    accountDetails: {
      accountType
    }
  } = Vue.auth.session.get();
  if (_includesInstanceProperty(types).call(types, accountType)) {
    return options.fn(this);
  }
  return options.inverse(this);
};
export const extractFromArray = function (array, index, param) {
  return param === "all" ? _JSON$stringify(array[index]) : array[index][param] || "";
};

/**
 * Helper to compare a userName with the current logged in user
 */

export const isCurrentUser = other => {
  const session = Vue.auth.session.get();
  if (!isEmpty(session)) {
    const {
      userDetails: {
        username
      }
    } = session;
    return username === other;
  } else {
    return false;
  }
};
export const JSONStringify = object => _JSON$stringify(object);

/**
 * Helper to extract a query param from current URL
 */
export const urlQueryParam = paramName => {
  const currentURL = new _URL(window.location.href.replace("#", ""));
  return currentURL.searchParams.get(paramName);
};

/**
 * Return the list of classes that apply to an activity list
 * or the most important one according to the importance order
 */

export const getOutput = (partial, key, value, extraData) => {
  return TimelineAssigneeTooltip({
    [key]: value,
    extraData
  });
};
export const portalDomain = (portal, subdomain) => {
  const host = window.location.host;
  const protocol = "https://";
  let {
    accountSubdomain
  } = Vue.auth.session.get().accountDetails;
  let domain = "doorr.com";
  let portalSubdomain = "";
  if (subdomain === "false") accountSubdomain = "";
  if (startsWith(host, "localhost")) return `http://localhost:3003/${accountSubdomain}`;
  if (portal === "client") {
    domain = "mortgage";
    portalSubdomain = ENVIRONMENT !== "production" ? `${ENVIRONMENT}.getmy` : "getmy";
  } else {
    portalSubdomain = ENVIRONMENT !== "production" ? `${portal}-${ENVIRONMENT}` : portal;
  }
  return `${protocol}${portalSubdomain}.${domain}/${accountSubdomain}`;
};
export const resolveWebpackSharedAsset = path => {
  const dataFiles = require.context("@Shared/@Assets/", true, /\.svg/);
  const filePath = path.split("shared/assets/")[1];
  return dataFiles(`./${filePath}`);
};
export const formatNumeral = (value, format) => {
  return numeral(value).format(format);
};
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("userAgent", userAgent);
  Handlebars.registerHelper("avatarPlaceholder", avatarPlaceholder);
  Handlebars.registerHelper("setNAValue", setNAValue);
  Handlebars.registerHelper("idForAgents", idForAgents);
  Handlebars.registerHelper("getVisible", getVisible);
  Handlebars.registerHelper("plusOne", plusOne);
  Handlebars.registerHelper("minusOne", minusOne);
  Handlebars.registerHelper("parsePercentage", parsePercentage);
  Handlebars.registerHelper("parsePercentageDecimal", parsePercentageDecimal);
  Handlebars.registerHelper("randomNumber", randomNumber);
  Handlebars.registerHelper("setVariable", setVariable);
  Handlebars.registerHelper("escapeURL", escapeURL);
  Handlebars.registerHelper("encodeURI", encodeURI);
  Handlebars.registerHelper("allEmptyFilenames", allEmptyFilenames);
  Handlebars.registerHelper("getProgressItemVariation", getProgressItemVariation);
  Handlebars.registerHelper("arrayLength", arrayLength);
  Handlebars.registerHelper("getProgressiveIndex", getProgressiveIndex);
  Handlebars.registerHelper("splitStringArray", splitStringArray);
  Handlebars.registerHelper("parseToJSON", parseToJSON);
  /**
   * Helper to show a block only to a specific account type
   */
  Handlebars.registerHelper("onlyFor", onlyFor);
  Handlebars.registerHelper("extractFromArray", extractFromArray);
  Handlebars.registerHelper("isCurrentUser", isCurrentUser);
  Handlebars.registerHelper("JSONStringify", JSONStringify);
  /**
   * Helper to extract a query param from current URL
   */
  Handlebars.registerHelper("urlQueryParam", urlQueryParam);
  /**
   * Return the list of classes that apply to an activity list
   * or the most important one according to the importance order
   */
  Handlebars.registerHelper("activityClass", activityClass);
  Handlebars.registerHelper("getOutput", getOutput);
  Handlebars.registerHelper("portalDomain", portalDomain);
  Handlebars.registerHelper("resolveWebpackSharedAsset", resolveWebpackSharedAsset);
};